import React,{useContext,useState, useEffect } from "react";
import { MDBRow, MDBCol } from 'mdbreact';
import CustomCheckboxTree from 'components/CheckboxTree/CheckboxTree';
import Cookies from 'universal-cookie';
import { WizardDataContext } from "context/WizardDataContext";
const cookies = new Cookies();

function Step2(props) { 
  let [nodeValue, setnodeValue] = useState(props.block.nodes);
  const [wizardData, setWizardData] = useContext(WizardDataContext)
  useEffect(() => {
    (async () => {
      
        if(props.futurename == 'Category'){
         const getdrpdwnresponseJson = wizardData.productsDetail;
        setnodeValue(getdrpdwnresponseJson.data.data);
        if(getdrpdwnresponseJson.data.hasOwnProperty('assignedCategories') === true) {
          if(getdrpdwnresponseJson.data.assignedCategories !== null)
            props.setSelectChildValueCheckbox(getdrpdwnresponseJson.data.assignedCategories.split(','))
        }
      }else {
        const getdrpdwnresponseJson = wizardData.productsView;
        setnodeValue(getdrpdwnresponseJson.data.modules);
      }
    })()
  }, [wizardData]);

  if (props.currentStep !== props.block.step) {
    return null
  }
  return(
  <div>
    <MDBRow>
      <MDBCol md="4" className="mb-3">
        <div className="custom-control custom-checkbox pl-3">
          <CustomCheckboxTree
            nodes={nodeValue}
            checked = {chk => props.checkboxcheck(chk)}
            expanded = {exp => props.checkboxexpand(exp)}
            selectChildValueCheckbox={props.selectChildValueCheckbox}
            selectChildValueCheckboxExpanded={props.selectChildValueCheckboxExpanded}
          />
              <span>{ (Object.keys(props.selectChildValueCheckbox).length == 0) ? 
                               props.validator.message('Minimum one Permission', props.selectChildValueCheckbox, 'required|email') : null}</span>
        </div>
      </MDBCol>
    </MDBRow>
  </div>
  );
}

export default Step2;